var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import FadeIn from '../../../components/Animation/FadeIn';
import Paragraph from '../../../components/Typography/Paragraph';
import { useValidation } from '../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormRow from '../../../components/Form/Row';
import TextInput from '../../../components/Fields/TextInput';
import { Fields } from '../../../utils/Fields';
import Button from '../../../components/Button';
import { useOutletContext } from 'react-router-dom';
import { serialize } from 'object-to-formdata';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { toast } from 'react-toastify';
import { deepEqual, pick } from '../../../utils/Objects';
import { usePlaceholder } from '../../../hooks/usePlaceholder';
var DashboardContact = function () {
    var fields = [
        'display_email',
        'phone',
        'social_instagram',
        'social_facebook',
        'social_linkedin',
        'social_twitter',
        'social_malt',
        'social_youtube',
        'social_tiktok',
        'social_other',
    ];
    var _a = useValidation(), emailRequired = _a.emailRequired, phoneOptional = _a.phoneOptional, urlOptional = _a.urlOptional;
    var _b = useOutletContext(), user = _b.user, handleUser = _b.handleUser, handleFormError = _b.handleFormError;
    var placeholders = usePlaceholder();
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var schema = yup.object().shape({
        display_email: emailRequired,
        phone: phoneOptional,
        social_instagram: urlOptional,
        social_facebook: urlOptional,
        social_linkedin: urlOptional,
        social_twitter: urlOptional,
        social_malt: urlOptional,
        social_youtube: urlOptional,
        social_tiktok: urlOptional,
        social_other: urlOptional,
    });
    var _d = useForm({
        resolver: yupResolver(schema),
        defaultValues: pick(user, fields),
    }), handleSubmit = _d.handleSubmit, control = _d.control, reset = _d.reset;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deepEqual(data, pick(user, fields)))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(data, { indices: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    reset(response.data);
                    toast.success('Vos informations ont bien été mises à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleFormError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (<FadeIn>
      <div className="my-10 grid gap-6 lg:my-20 lg:grid-cols-12">
        <div className="lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3">
          <Paragraph className="mb-8 font-medium">
            Indiquez les coordonnées que vous souhaitez afficher sur votre profil et profitez de
            nouvelles opportunités&nbsp;!
          </Paragraph>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-6">
              <FormRow>
                <TextInput label="Email" type={Fields.EMAIL} name="display_email" instructions="Cette adresse email peut être différente de votre email de connexion." placeholder={placeholders.email} control={control} required/>
              </FormRow>
              <FormRow>
                <TextInput label="Téléphone" type={Fields.PHONE} name="phone" placeholder={placeholders.phone} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Instagram" type={Fields.TEXT} name="social_instagram" placeholder={placeholders.social_instagram} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Facebook" type={Fields.TEXT} name="social_facebook" placeholder={placeholders.social_facebook} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Linkedin" type={Fields.TEXT} name="social_linkedin" placeholder={placeholders.social_linkedin} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Twitter" type={Fields.TEXT} name="social_twitter" placeholder={placeholders.social_twitter} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Malt" type={Fields.TEXT} name="social_malt" placeholder={placeholders.social_malt} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Youtube" type={Fields.TEXT} name="social_youtube" placeholder={placeholders.social_youtube} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Tiktok" type={Fields.TEXT} name="social_tiktok" placeholder={placeholders.social_tiktok} control={control}/>
              </FormRow>
              <FormRow>
                <TextInput label="Autre" type={Fields.TEXT} name="social_other" placeholder={placeholders.social_other} control={control}/>
              </FormRow>
              <Button submit loading={loading} className="sm:self-end">
                Mettre à jour mes coordonnées
              </Button>
            </div>
          </form>
        </div>
      </div>
    </FadeIn>);
};
export default DashboardContact;
